import { Injectable } from "@angular/core";
import { DbDaoBase } from "../../../gyzmo-commons/dao/db/base/db.dao.base";
import { isNullOrEmpty } from "../../../gyzmo-commons/helpers/null.helper";
import { AppSqlProvider } from "../../../gyzmo-commons/persistence/app.sql.provider";
import { LoggerService } from "../../../gyzmo-commons/services/logs/logger.service";
import { Server } from "../../models/server.model";

@Injectable({
    providedIn: "root",
})
export class ServerDbDao extends DbDaoBase<Server> {
    constructor(logger: LoggerService,
                private sqlProvider: AppSqlProvider) {
        super(logger);
    }

    public list(): Promise<Server[]> {
        const query = `SELECT * FROM ${ Server.TABLENAME };`;
        const params: any[] = [];
        return this.sqlProvider.query(query, params)
            .then(data => {
                if (data.rows.length <= 0) {
                    return [];
                }
                let servers: Server[] = [];
                for (const item of data.rows) {
                    servers.push(this.rowToModel(item));
                }
                return servers;
            })
            .catch(reason => {
                this.logSqlError(reason);
                return [];
            });
    }

    public async createIndexes(): Promise<void> {
        // Ajoutez ici la création des index si nécessaire
    }

    public createTable(): Promise<void> {
        const query = `CREATE TABLE IF NOT EXISTS ${ Server.TABLENAME } (
            id NUMERIC PRIMARY KEY,
            name TEXT,
            url TEXT,
            apiKey TEXT,
            defaultToken TEXT,
            token TEXT,
            inspectionApiVersion NUMERIC,
            context TEXT
        );`;
        const params: any[] = [];
        return this.sqlProvider.query(query, params)
            .then(async () => {
                await this.createIndexes();
            })
            .catch(reason => {
                this.logSqlError(reason);
                return null;
            });
    }

    public delete(id: string): Promise<any> {
        const query = `DELETE FROM ${ Server.TABLENAME } WHERE id = ?;`;
        const params: any[] = [id];
        return this.sqlProvider.query(query, params);
    }

    public deleteAll(): Promise<any> {
        const query = `DELETE FROM ${ Server.TABLENAME };`;
        const params: any[] = [];
        return this.sqlProvider.query(query, params);
    }

    public get(id: string, hydrate: boolean): Promise<Server> {
        if (isNullOrEmpty(id)) {
            return Promise.resolve(null);
        }
        const query = `SELECT * FROM ${ Server.TABLENAME } WHERE id = ?;`;
        const params: any[] = [id];
        return this.sqlProvider.query(query, params)
            .then(data => {
                if (data.rows.length <= 0) {
                    return new Server();
                }
                return this.rowToModel(data.rows[0]);
            })
            .catch(reason => {
                this.logSqlError(reason);
                return new Server();
            });
    }

    public getTableName(): string {
        return Server.TABLENAME;
    }

    protected rowToModel(row: any): Server {
        let server = new Server();
        server.id = row.id;
        server.name = row.name;
        server.url = row.url;
        server.apiKey = row.apiKey;
        server.defaultToken = row.defaultToken;
        server.token = row.token;
        server.context = row.context;
        server.inspectionApiVersion = row.inspectionApiVersion;
        return server;
    }

    public save(server: Server): Promise<Server> {
        const query = `INSERT OR REPLACE INTO ${ Server.TABLENAME } (
            id, name, url, apiKey, defaultToken, token, inspectionApiVersion, context
        ) VALUES (?, ?, ?, ?, ?, ?, ?, ?);`;
        const params: any[] = [
            server.id,
            server.name,
            server.url,
            server.apiKey,
            server.defaultToken,
            server.token,
            server.inspectionApiVersion,
            server.context,
        ];
        return this.sqlProvider.query(query, params)
            .then(response => {
                return server;
            })
            .catch(reason => {
                this.logSqlError(reason);
                return null;
            });
    }
}
